export default function(variableName, palette) {
    const root = document.querySelector(':root');
    palette.forEach((color) => {
        const colorName = variableName + color.name;
        root.style.setProperty(colorName, color.hex);
    });
}